module.exports = __webpack_public_path__ + "static/img/美化.6c16c66c.png";